<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="仓库名称">
                  <el-input style="width: 177px;" v-model="queryForm.warehouseName"></el-input>
              </el-form-item>
              <el-form-item label="拣分人姓名">
                  <el-input style="width: 177px;" v-model="queryForm.personName"></el-input>
              </el-form-item>
              <el-form-item label="拣分人电话">
                  <el-input style="width: 177px;" v-model="queryForm.personMobile"></el-input>
              </el-form-item>
              <el-form-item label="用户">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelectU style="width: 177px;" labelName="userName"
                    labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                    @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="备注">
                  <el-input style="width: 177px;" v-model="queryForm.remarks"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopSortingList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopSorting"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopSorting(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopSorting(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopSortingList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopSortingList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopSortingList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="warehouseName"
        label="仓库名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="personName"
        label="拣分人姓名"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="personHeader"
        label="拣分人头像"
        min-width="180"
      >
        <template slot-scope="scope">
          <div v-if='scope.row.personHeader'>
            <el-image @click='updateSrcList(scope.row.personHeader)' style="width: 60px; height: 60px"
              :src="scope.row.personHeader" :preview-src-list="srcList"> </el-image>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="personMobile"
        label="拣分人电话"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        min-width="180"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.user">
              <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
              <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
              <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
              <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="remarks"
        label="备注"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="allotUser(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">配送门店</span>
              </div> 
            <div @click="checkShopSorting(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopSorting(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopSorting(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopSortingStates[shopSortingState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopSorting"
          ref="shopSortingForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="仓库名称"
            prop="warehouseName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="shopSorting.warehouseName"
              :disabled="shopSortingState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="拣分人姓名"
            prop="personName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="shopSorting.personName"
              :disabled="shopSortingState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="拣分人电话"
            prop="personMobile"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="shopSorting.personMobile"
              :disabled="shopSortingState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="shopSorting.userId"
              :disabled="shopSortingState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="shopSortingState == 'check'"
              labelValue="id" :value="shopSorting.userId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="remarks"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="shopSorting.remarks"
              :disabled="shopSortingState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="拣分人头像"
            prop="personHeader"
          >
            <!-- <el-input
              size="small"
              v-model="shopSorting.personHeader"
              :disabled="shopSortingState == 'check'"
            ></el-input> -->
            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
              :disabled="shopSortingState == 'check'" class="avatar-uploader" :show-file-list="false"
              :http-request="uploadImage">
              <img v-if="shopSorting.personHeader" :src="shopSorting.personHeader" class="avatar" size="small" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopSortingState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  <AllotStore ref="allotStore" :id="currentRole"></AllotStore>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import { UPLOAD_PATH, UPLOAD_API, USER, USER_SEARCH } from '@/utils/constant.js';
import AllotStore from '@/components/StoreManagement/AllotStore.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU,
        AllotStore
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopSortingList();
                    this.getShopSortingList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopSortingList();
                    this.getShopSortingList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     warehouseName: '', //仓库名称
                     personName: '', //拣分人姓名
                     personHeader: '', //拣分人头像
                     personMobile: '', //拣分人电话
                     userId: '', //用户
                     remarks: '', //备注
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                header: {
                  token: localStorage.getItem('token')
                },
                currentRole : '',
                action: UPLOAD_API + UPLOAD_PATH,
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopSortingState: 'add',
                shopSortingStates: {
                    add: '新建shop_sorting',
                    check: '查看shop_sorting',
                    edit: '修改shop_sorting'
                },

                multipleSelection: [],
                shopSortingList: [],
                shopSorting: {
                    id: '', //ID
                    warehouseName: '', //仓库名称
                    personName: '', //拣分人姓名
                    personHeader: '', //拣分人头像
                    personMobile: '', //拣分人电话
                    userId: '', //用户
                    remarks: '', //备注
                    createTime: '', //
                },
                btnLoading: false,

                rules: {
                    warehouseName: [{ required: true, message: '仓库名称不能为空', trigger: 'blur' }],
                    personName: [{ required: true, message: '拣分人姓名不能为空', trigger: 'blur' }],
                    personHeader: [{ required: true, message: '拣分人头像不能为空', trigger: 'blur' }],
                    personMobile: [{ required: true, message: '拣分人电话不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    // remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopSortingList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            updateSrcList(res){
              this.srcList[0] = res;
            },
            resetShopSortingList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopSortingList = [];
            },
            allotUser(role) {
              //console.log(role);
              this.currentRole = role;
              setTimeout(() => {
                  this.$refs.allotStore.init1();
              }, 200);
            },
            beforeImageUpload(file) {
              const isLt2M = file.size / 1024 / 1024 < 50;
              if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
              }
              return isLt2M;
            },
            //上传缩略图
            uploadImage(params) {
              console.log(params);
              const file = params.file;
              let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
              if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
              }
              const formData = new FormData();
              formData.append('file', file);
              upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                  this.shopSorting.personHeader = res.url;
                }
              });
            },
            getValueUser(value) {
              this.shopSorting.userId = value
            },
            getSeachValueUser(value){
              this.queryForm.userId = value
            },
            resetDialog() {
                this.shopSortingState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      warehouseName: '', //仓库名称
                      personName: '', //拣分人姓名
                      personHeader: '', //拣分人头像
                      personMobile: '', //拣分人电话
                      userId: '', //用户
                      remarks: '', //备注
                };
                this.getShopSortingList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopSorting = {
                      id: '', //ID
                      warehouseName: '', //仓库名称
                      personName: '', //拣分人姓名
                      personHeader: '', //拣分人头像
                      personMobile: '', //拣分人电话
                      userId: '', //用户
                      remarks: '', //备注
                };
            },
            submitForm() {
                if (this.shopSortingState == 'add') {
                    this.$refs.shopSortingForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/restaurant/sorting/add`,{ ...this.shopSorting }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopSortingList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopSortingState == 'edit') {
                    this.$refs.shopSortingForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopSorting.user
                            post(`/restaurant/sorting/edit`,{ ...this.shopSorting }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopSortingList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopSorting() {
                this.showDialog = true;
                this.shopSortingState = 'add';
            },
            checkShopSorting(shopSortingId) {
                console.log(shopSortingId);
                this.currentShopSortingId = shopSortingId;

                this.getShopSortingById();
                this.showDialog = true;
                this.shopSortingState = 'check';
            },
            editShopSorting(shopSortingId) {
                console.log('shopSorting', shopSortingId);
                if (shopSortingId) {
                    this.currentShopSortingId = shopSortingId;
                    this.getShopSortingById();
                } else {
                    this.shopSorting = { ...this.shopSorting, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopSortingState = 'edit';
            },
            deleteShopSorting(shopSortingId) {
                let ids = '';
                if (shopSortingId) {
                    ids = shopSortingId;
                } else {
                    ids = this.multipleSelection.map((shopSorting) => shopSorting.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/restaurant/sorting/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopSortingList();
                                this.getShopSortingList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopSortingList() {
                this.resetShopSortingList();
                this.getShopSortingList();
            },
            getShopSortingList(query = {}) {
                this.loading = true;
                get(`/restaurant/sorting/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopSortingList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopSortingById() {
                get(`/restaurant/sorting/get`,{ id: this.currentShopSortingId }).then((res) =>{
                    if(res.success){
                      this.shopSorting = { ...this.shopSorting, ...res.shopSorting };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopSortingList() {
                //this.btnLoading = true;
                exprotExcel(`/restaurant/sorting/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/restaurant/sorting/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/restaurant/sorting/importData`,formData);
              this.refreshShopSortingList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopSortingList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopSortingList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.avatar {
  width: 177px;
  height: 177px;
  display: block;
}

::v-deep .el-upload--text {
  width: 177px;
  height: 177px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 177px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>